import React from "react";
//i18n
import { withNamespaces } from "react-i18next";
import {
  Container,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import {  withRouter } from "react-router-dom";
//Import Breadcrumb
import Breadcrumb_2Items from "../../../components/Common/Breadcrumb_2Items";
import ItemOrders from "../../../components/Orders/Items/AllOrders"


const AllItemOrders = (props) => {


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Items")}
            title={props.t("Orders")}
            breadcrumbItem1={props.t("Items")}
            breadcrumbItem2={props.t("All Orders")}
          />

          <ItemOrders />

       </Container>
      </div>   


    </React.Fragment>
  );
};

export default withRouter(connect(null, {})(withNamespaces()(AllItemOrders)));
